// extracted by mini-css-extract-plugin
export default {"container":"MessageFormBody_container__VNXnM","dropdownContainer":"MessageFormBody_dropdownContainer__K91tO"};